<template>
    <div>
        <EditShelter />
    </div>
</template>

<script>
import EditShelter from '@/components/shelter/EditShelter.vue';
export default {
    components: {
        EditShelter
    },
    name: 'ShelterEdit'
}
</script>